import React from "react";

function youtubeId(url) {
  try {
    const u = new URL(url);
    if (u.hostname.includes("youtu.be")) return u.pathname.split("/").filter(Boolean)[0] || "";
    if (u.pathname.startsWith("/shorts/")) return u.pathname.split("/")[2] || "";
    if (u.pathname.startsWith("/embed/")) return u.pathname.split("/")[2] || "";
    return u.searchParams.get("v") || "";
  } catch (_) { return ""; }
}
function vimeoId(url) {
  try { return new URL(url).pathname.split("/").filter(Boolean).find((part) => /^\d+$/.test(part)) || ""; }
  catch (_) { return ""; }
}
function mixcloudFeed(url) {
  try { return new URL(url).pathname; } catch (_) { return ""; }
}
function formatBytes(bytes) {
  const n = Number(bytes || 0);
  if (!Number.isFinite(n) || n <= 0) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
function artifactIsImage(data = {}) {
  if (typeof data.is_image === "boolean") return data.is_image;
  return /\.(jpe?g|png|webp)$/i.test(String(data.filename || ""));
}

function MediaFrame({ data }) {
  const provider = data.provider;
  const url = data.url || "";
  let src = "";
  let className = "fieldnote-embed fieldnote-embed--video";
  let title = `${provider || "media"} player`;

  if (provider === "youtube") {
    const id = youtubeId(url); if (!id) return null;
    src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?rel=0`;
  } else if (provider === "vimeo") {
    const id = vimeoId(url); if (!id) return null;
    src = `https://player.vimeo.com/video/${encodeURIComponent(id)}?title=0&byline=0&portrait=0`;
  } else if (provider === "soundcloud") {
    className = "fieldnote-embed fieldnote-embed--audio";
    src = `https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&visual=false`;
  } else if (provider === "mixcloud") {
    const feed = mixcloudFeed(url); if (!feed) return null;
    className = "fieldnote-embed fieldnote-embed--audio";
    src = `https://www.mixcloud.com/widget/iframe/?hide_cover=1&light=1&feed=${encodeURIComponent(feed)}`;
  } else if (provider === "bandcamp") {
    if (!/\/EmbeddedPlayer\//i.test(url)) return null;
    className = "fieldnote-embed fieldnote-embed--bandcamp";
    src = url;
  } else return null;

  const style = provider === "bandcamp" ? { height: /size=large/i.test(url) ? 470 : 120 } : undefined;
  return <iframe className={className} style={style} src={src} title={title} loading="lazy" allow="autoplay; fullscreen; picture-in-picture; encrypted-media" allowFullScreen referrerPolicy="no-referrer" />;
}

function FieldNoteBlock({ block }) {
  if (!block) return null;
  const data = block.data || {};

  if (block.block_type === "artifact") {
    if (!data.url) return null;

    if (artifactIsImage(data)) {
      return (
        <figure className="fieldnote-artifact">
          <img src={data.url} alt={data.alt || data.caption || "Field Note artifact"} loading="lazy" />
          {(data.caption || data.credit) && (
            <figcaption>
              {data.caption && <span>{data.caption}</span>}
              {data.credit && <small>{data.credit}</small>}
            </figcaption>
          )}
        </figure>
      );
    }

    const filename = data.original_name || "Field Note artifact";
    const details = [data.mime, formatBytes(data.size)].filter(Boolean).join(" · ");
    return (
      <figure className="fieldnote-artifact fieldnote-artifact--file">
        <div className="fieldnote-file-artifact-card">
          <div className="fieldnote-file-artifact-icon" aria-hidden="true">FILE</div>
          <div className="fieldnote-file-artifact-info">
            <strong>{filename}</strong>
            {details && <small>{details}</small>}
            {data.caption && <span>{data.caption}</span>}
            {data.credit && <small>{data.credit}</small>}
          </div>
          <a className="btn btn-outline-primary btn-sm" href={data.url} download={filename}>Download</a>
        </div>
      </figure>
    );
  }

  if (block.block_type === "media") {
    return <figure className="fieldnote-media-block"><MediaFrame data={data} />{data.caption && <figcaption>{data.caption}</figcaption>}</figure>;
  }
  return null;
}
export default FieldNoteBlock;
